import TWEEN from '@tweenjs/tween.js';
import {USE_LEGACY_TWEEN_GROUP} from 'components/customer/Preview3DCommon/lib/tween';
import {AnimationPair, TargetParams} from './types';

// 'target' strategy — "arrive exactly here."
//
// Writes an absolute interpolated value every frame so the axis lands on the
// target regardless of any concurrent perturbation. The tween owns the axis
// for its lifetime; other writers during the tween will be clobbered.
export const targetStrategy = (params: TargetParams): AnimationPair => {
    const {
        mesh,
        property,
        axis,
        openDelay = 0,
        closeDelay = 0,
        openDuration = 1000,
        closeDuration = 1000,
    } = params;

    const easing = params.easing ?? TWEEN.Easing.Quadratic.Out;

    const runTween = (
        targetValue: number,
        animDuration: number,
        delayBeforeStart: number
    ) =>
        new Promise<void>((resolve) => {
            // eslint-disable-next-line security/detect-object-injection -- property and axis are validated by internal state of three.js
            const state = {value: mesh[property][axis]};
            new TWEEN.Tween(state, USE_LEGACY_TWEEN_GROUP)
                .to({value: targetValue}, animDuration)
                .easing(easing)
                .delay(delayBeforeStart)
                .onComplete(() => resolve())
                .onUpdate(() => {
                    // eslint-disable-next-line security/detect-object-injection -- property and axis are validated by internal state of three.js
                    mesh[property][axis] = state.value;
                })
                .start();
        });

    return {
        open: (animDuration = openDuration) => {
            const {openTarget} = params.getTargets();
            return runTween(openTarget, animDuration, openDelay);
        },
        close: (animDuration = closeDuration) => {
            const {closeTarget} = params.getTargets();
            return runTween(closeTarget, animDuration, closeDelay);
        },
    };
};
